export * from './config';
export * from './dialog';
export * from './coupon';
export * from './share';

/** 链接参数 */
export enum UrlParams {
  /** 分享码 */
  'c2cShareCode' = 'c2cShareCode',
  /** 是否拉起裂变弹窗 */
  'showC2CDialog' = 'showC2CDialog',
}

/** 用户类型 */
export enum C2CUserType {
  /** 本人 */
  'isSelf' = 'isSelf',
  /** 非本人 */
  'notSelf' = 'notSelf',
}

/** tabId */
export enum NavTabId {
  'success' = 0,
  'ing',
  'failed',
}
